import React from 'react';
export function Footer() {
  return <footer className="bg-petrol-deep px-4 pb-28 pt-14 text-center md:pb-14" data-id="element-86" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl" data-id="element-87" data-mp="3ggaohovss12a">
        <div className="font-heading text-lg font-semibold tracking-[0.14em] text-white" data-id="element-88" data-mp="3gh3rcermy6f5">PILATES REFORMER PRONTO</div>
        <p className="mx-auto mt-5 max-w-xl font-note text-[11px] leading-relaxed text-white/55" data-id="element-89" data-mp="36p6cmy1f4wbo">
          Pilates Reformer Pronto è un prodotto digitale di supporto didattico rivolto a istruttrici e istruttori di
          Pilates Reformer già qualificati. Non sostituisce un percorso di formazione certificato, né costituisce una
          consulenza medica o riabilitativa. L&apos;utilizzo del materiale con allieve e allievi resta sotto la
          responsabilità professionale dell&apos;istruttore, che è tenuto a valutare le condizioni individuali di
          ciascuna persona prima di proporre qualsiasi esercizio.
        </p>
        <nav aria-label="Note legali" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-90" data-mp="2ez1kgd7f34zw">
          <a href="#termini" className="font-note text-xs text-white/70 transition-colors duration-150 ease-out hover:text-white" data-id="element-91" data-mp="3la29svmrl5vr">
            Termini e condizioni
          </a>
          <a href="#privacy" className="font-note text-xs text-white/70 transition-colors duration-150 ease-out hover:text-white" data-id="element-92" data-mp="3v91a9qxdlv7o">
            Privacy
          </a>
          <a href="#contatti" className="font-note text-xs text-white/70 transition-colors duration-150 ease-out hover:text-white" data-id="element-93" data-mp="817e07obdsul">
            Contatti
          </a>
        </nav>
        <p className="font-note text-[11px] text-white/45" data-id="element-94" data-mp="huo6978syzw5">
          © 2026 Pilates Reformer Pronto — Tutti i diritti riservati
        </p>
      </div>
    </footer>;
}